import React, { CSSProperties } from "react";
import { SpacingBox, SpacingBoxProps } from "./spacing-box";

type FlexLayoutProps = SpacingBoxProps & {
    direction?: CSSProperties["flexDirection"];
    align?: CSSProperties["alignItems"];
    justify?: CSSProperties["justifyContent"];
};

export const FlexLayout: React.FC<FlexLayoutProps> = ({
    direction = "row",
    align = "stretch",
    justify = "flex-start",
    ...rest
}: FlexLayoutProps) => {
    const style: CSSProperties = {
        display: "flex",
        justifyContent: justify,
        alignItems: align,
        flexDirection: direction,
        ...rest.style,
    };
    return (
        <SpacingBox
            data-testid="FlexLayout"
            {...rest}
            style={style}
        ></SpacingBox>
    );
};

export const Row: React.FC<Omit<FlexLayoutProps, "direction">> = (
    props: Omit<FlexLayoutProps, "direction">
) => <FlexLayout data-testid="Row" {...props} direction="row" />;

export const Column: React.FC<Omit<FlexLayoutProps, "direction">> = (
    props: Omit<FlexLayoutProps, "direction">
) => <FlexLayout data-testid="Column" {...props} direction="column" />;
